import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import StudentBar from "../students/StudentBar";
import YearForm from "./YearForm";
import ArchiveForm from "./ArchiveForm";

class Year extends Component {
    state = { isModal: false, isModalArchive: false, loading: false, formData: "", years: [], years_: [] };

    componentDidMount() { this.getYears(); this.getYears_(); }

    async getYears() {
        try {
            const response = await axios.get("yearslistetabli");
            if (response.status === 200) this.setState({ years: response.data, loading: true });
        } catch (error) {
            this.setState({ loading: true });
            toast.error("Impossible de charger les années scolaires.");
        }
    }

    async getYears_() {
        try {
            const response = await axios.get("years_");
            if (response.status === 200) this.setState({ years_: response.data });
        } catch (error) { toast.error("Impossible de charger la liste des années."); }
    }

    showModal = (year = null) => {
        this.setState((state) => ({ isModal: !state.isModal, formData: year }));
        if (year === null) this.getYears();
    };

    showModalArchive = (year = null) => {
        this.setState((state) => ({ isModalArchive: !state.isModalArchive, formData: year }));
        this.getYears();
    };

    handleCheck(permission) {
        try { return JSON.parse(localStorage.getItem("permissions") || "[]").some((item) => permission === item.permission); }
        catch (error) { return false; }
    }

    getYearStats = (year) => {
        const all = this.state.years?.students || [];
        const students = all.filter((student) => student.yearId == year.id && student.operation !== "Supprimer");
        return {
            students: students.length,
            active: students.filter((student) => student.status === 1).length,
            inactive: students.filter((student) => student.status === 2).length,
            abandoned: all.filter((student) => student.yearId == year.id && student.status === 0).length,
            girls: students.filter((student) => student.user?.genre === "Feminin" || student.user?.genre === "").length,
            boys: students.filter((student) => student.user?.genre === "Masculin" || student.user?.genre === "M").length,
            parents: year.parentfamilies?.length || 0, staff: year.staffs?.length || 0,
            suppliers: year.suppliers?.length || 0, classes: year.sectionclasses?.length || 0,
        };
    };

    renderYearCard = (year) => {
        const stats = this.getYearStats(year);
        const isActive = Number(year.status) === 1;
        const canEdit = this.handleCheck("Modifier année") && isActive;
        const metrics = [
            ["users", stats.parents, "Parents"], ["briefcase", stats.staff, "Personnel"],
            ["truck", stats.suppliers, "Fournisseurs"], ["book-open", stats.classes, "Classes"],
        ];
        return (
            <article className="school-year-card" key={year.id}>
                <header className="school-year-card__header">
                    <div className="school-year-card__identity">
                        <span className="school-year-card__calendar"><FeatherIcon icon="calendar" size={21} /></span>
                        <div><span className="school-year-eyebrow">Année scolaire</span><h3>{year.year}</h3></div>
                    </div>
                    <div className="school-year-card__tools">
                        <span className={`school-year-status ${isActive ? "is-current" : "is-archived"}`}>
                            <i />{isActive ? "Active" : "Archivée"}
                        </span>
                        {canEdit && <div className="school-year-actions">
                            <button type="button" onClick={() => this.showModal(year)}><FeatherIcon icon="edit-2" size={15} /> Modifier</button>
                            <button type="button" onClick={() => this.showModalArchive(year)}><FeatherIcon icon="archive" size={15} /> Archiver</button>
                        </div>}
                    </div>
                </header>
                <div className="school-year-card__body">
                    <section className="school-year-students">
                        <div className="school-year-students__total"><span><FeatherIcon icon="user" size={23} /></span><div><strong>{stats.students}</strong><small>Élèves inscrits</small></div></div>
                        <div className="school-year-students__status">
                            <span className="is-active"><b>{stats.active}</b> Actifs</span>
                            <span className="is-inactive"><b>{stats.inactive}</b> Non actifs</span>
                            <span className="is-abandoned"><b>{stats.abandoned}</b> Archivés</span>
                        </div>
                    </section>
                    <section className="school-year-gender" aria-label="Répartition des élèves">
                        <span><FeatherIcon icon="pie-chart" size={19} /></span><div><small>Filles</small><strong>{stats.girls}</strong></div><i /><div><small>Garçons</small><strong>{stats.boys}</strong></div>
                    </section>
                    <section className="school-year-metrics">
                        {metrics.map(([icon, value, label]) => <div className="school-year-metric" key={label}><span><FeatherIcon icon={icon} size={17} /></span><div><strong>{value}</strong><small>{label}</small></div></div>)}
                    </section>
                </div>
            </article>
        );
    };

    render() {
        const yearData = this.state.years?.data || [];
        const ordered = (this.state.years_ || []).flatMap((item) => yearData.filter((year) => year.id == item.id));
        const years = ordered.length ? ordered : yearData;
        const labels = years.map((year) => year.year);
        const data = years.map((year) => this.getYearStats(year).students);
        return (
            <div className="school-years">
                <Helmet><title>{process.env.REACT_APP_NAME} | Années scolaires</title></Helmet>
                <header className="school-years__heading">
                    <div><p>Suivez les effectifs et les ressources de chaque période.</p></div>
                    {this.handleCheck("Ajouter année") && <button type="button" className="school-years__add" onClick={() => this.showModal(null)}><FeatherIcon icon="plus" size={17} /> Nouvelle année</button>}
                </header>
                {!this.state.loading ? <div className="school-years__loading"><FeatherIcon className="user-search-spin" icon="loader" /><span>Chargement des années scolaires…</span></div>
                    : years.length ? <div className="school-years__list">{years.map(this.renderYearCard)}</div>
                    : <div className="school-years__empty"><span><FeatherIcon icon="calendar" size={24} /></span><strong>Aucune année scolaire</strong><small>Créez une année pour commencer à organiser vos données.</small></div>}
                {labels.length > 0 && <section className="school-years-chart">
                    <header><span><FeatherIcon icon="bar-chart-2" size={18} /></span><div><small>Vue comparative</small><h3>Évolution des effectifs</h3></div></header>
                    <div className="school-years-chart__body"><StudentBar labels={labels} data={data} title="Élèves par année scolaire" /></div>
                </section>}
                <YearForm isModal={this.state.isModal} formData={this.state.formData} showModal={this.showModal} />
                <ArchiveForm isModal={this.state.isModalArchive} formData={this.state.formData} showModal={this.showModalArchive} />
            </div>
        );
    }
}
export default Year;
